<rask-selector
  class="ps-0 mb-3"
  label="måttslag"
  [values]="options"
  [showHeader]="true"
  [disabled]="kontraktReadonly || atgard?.isUtfort"
  [formatter]="genericItemFormatter"
  [viewFormatter]="genericViewFormatter"
  [ngModel]="selected"
  [portalToBody]="false"
  (ngModelChange)="onMattslagChange($event)">
</rask-selector>

@if (avverkningskostnader) {
  <table class="simple-table" raskTableKeyboardNavigation>
    <thead>
      <tr>
        <th>Kostnader</th>
        <th>Kr per måttslag</th>
        <th>Kr per m3f</th>
        <th>Totalt</th>
      </tr>
    </thead>
    <tbody>
      @for (kostnad of avverkningskostnader; track kostnad) {
        <tr>
          <td class="disabled">{{kostnad.typ}}</td>
          <td [ngClass]="{ 'overridden': kostnad.kostnadBeraknadTotal === true }">
            <rask-input [disabled]="kontraktReadonly || atgard?.isUtfort" class="grid-input"
              [inputProcessor]="numberProcessor"
              id="krPerMattslag" [(ngModel)]="kostnad.krPerMattslag"
            (change)="krPerMattslagChanged($event, kostnad)"></rask-input>
          </td>
          <td class="disabled">
            <rask-input [readonly]="true" class="grid-input" id="krPerM3Fub"
            [value]="kostnad.krPerM3FubPresentation"></rask-input>
          </td>
          <td [ngClass]="{ 'overridden': kostnad.kostnadBeraknadTotal === false }">
            <rask-input [disabled]="kontraktReadonly || atgard?.isUtfort" class="grid-input"
              [inputProcessor]="numberProcessor"
              id="totalt" [(ngModel)]="kostnad.total"
            (change)="totalValueChange($event, kostnad)"></rask-input>
          </td>
        </tr>
      }
    </tbody>
    <tfoot>
      <tr class="disabled">
        <td>Summa</td>
        <td>{{ sumKrPerMattslag() }}</td>
        <td>{{ sumKrPerM3Fub() }}</td>
        <td>{{ sumTotal() }}</td>
      </tr>
    </tfoot>
  </table>
}